<template>
  <AppAlert type="info">
    {{ $tt('suggest_later_pic') }}
    <a @click="$emit('agree')">{{ $tt('click_here') }}</a>
  </AppAlert>
</template>

<script setup lang="ts">
defineEmits(['agree']);
</script>